import * as api from '../utils/api';
import * as types from './actionTypes';

export const loadWidgetsSuccess = data => ({
  type: types.LOAD_WIDGETS_SUCCESS, info: data,
});

export const loadWidgets = buildingId => function (dispatch) {
  return api.getWidgets(buildingId).then((data) => {
    dispatch(loadWidgetsSuccess(data));
  }).catch((err) => {
    throw (err);
  });
};

export const loadFoyers = alias => function (dispatch) {
  return api.getFoyers(alias).then((data) => {
    dispatch(loadWidgetsSuccess(data));
  }).catch((err) => {
    throw (err);
  });
};

export const loadWeatherSuccess = data => ({
  type: types.LOAD_WEATHER_SUCCESS, info: data,
});

export const loadWeather = days => function (dispatch, getState) {
  let { widgetReducer: { leftPanel: { building: { city, state, country  } } } } = getState();
  if(country) city = city + ', ' + state + ', ' + country
  return api.getSidebarInfo(city, days).then((data) => {
    dispatch(loadWeatherSuccess(data));
  }).catch((err) => {
    throw (err);
  });
};

export const toggleMenu = () => ({
  type: types.TOGGLE_MOBILE,
});
